export default {
  "finishAuthority": "Solo il segnapunti può finire questo round.",
  "finishDraft": "Confermare o ripristinare i punteggi di bozza prima di terminare.",
  "finishScoreRetry": "I punteggi non sono stati salvati. Controllare la connessione e riprovare.",
  "finishSavingScores": "In attesa che i risparmi di punteggio vengano riconosciuti.",
  "finishStatsRetry": "Risolvere o riprovare le statistiche non salvate in Hole view.",
  "finishSavingStats": "Aspettando che le tue statistiche finiscano di risparmiare.",
  "finishMissingScores": "Ogni giocatore ha bisogno di un punteggio confermato su ogni buco.",
  "finishingRound": "Finitura...",
  "holeSaveError": "La posizione di visualizzazione non può essere salvata. I punteggi vengono salvati separatamente.",

  "scorecardHeading": "Scheda di punteggio",
  "playersScored": "{count} giocatori su {total} con punteggio",
  "yourScorecard": "Il tuo punteggio",
  "roundView": "Vista panoramica",
  "scoreCoverageShort": "{count} giri confrontabili su {total}",
  "offline": "Offline — in attesa di salvare",
  "noPutts": "Nessun putt registrato ancora",
  "excludedReasons": "Escluso in questa finestra: {scores} giri con punteggi incompleti; {par} giri con par storico mancante.",
  "playVideo": "Buco di gioco {number} video",
  "pauseVideo": "Pausa buco {number} video",
  "puttChoice": "{count} putt",
  "exactPutts": "Conto di putt esatto",
  "apply": "Applica",
  "cancel": "Annulla",
  "tapToClear": "Tocca una risposta selezionata per cancellare.",
  "personal": "Il mio segnapunti",
  "group": "Gruppo",
  "cardView": "Vista panoramica",
  "unrecorded": "Non registrato",
  "strokes": "ictus registrati",
  "scoredCoverage": "{count} buche su {total} con punteggio",
  "parCoverage": "{count} buche con par affidabile",
  "legend": "Aiuto di Scorecard",
  "legendHelp": "FW: fairway. GIR: green in regulation. ✓ Raggiunto / Sì; × Mancato / No; — non registrato; N/A non applicabile. Tocca un numero di buca per tornare all’inserimento del punteggio.",
  "hole": "Buca",
  "par": "Pari",
  "score": "Punteggio",
  "goHole": "Vai al buco {number}",
  "recordedStrokes": "Ictus registrati",
  "continueHole": "Proseguire al buca {number}",
  "draft": "Bozza",
  "holePosition": "{number} / {total}",
  "holeNumber": "Buca {number}",
  "strokeIndex": "SI",
  "metres": "m m m m",
  "yards": "D'accordo.",
  "card": "Carta di carta",
  "finishRound": "Finitura rotonda",
  "swipeCard": "Scheda di punteggio per buche scorrevoli",
  "holeNavigation": "Navigazione del buca",
  "previousHole": "buca precedente",
  "nextHole": "Prossimo buca",
  "reviewCard": "Scheda di valutazione",
  "guest": "Ospite",
  "scorer": "Punteggio",
  "member": "Socio",
  "toPar": "rispetto al par",
  "reset": "Reimposta",
  "confirmScore": "Conferma {score}",
  "decreaseScore": "Diminuzione del punteggio {name}",
  "increaseScore": "Aumentare il punteggio di {name}",
  "confirmPlayerScore": "Confermare il punteggio {score} per {name}",
  "draftScore": "Punteggio {score}",
  "savedScore": "Punteggio ridotto {score}",
  "keepingCard": "{name} sta tenendo questo segnapunti.",
  "scoringTrend": "Evoluzione del punteggio",
  "viewData": "Visualizza i dati",
  "roundsLogged": "Rotonde registrate",
  "recentRounds": "Recenti round",
  "firstTitle": "I tuoi progressi iniziano con un round",
  "firstHelp": "Completa un round per seguire i tuoi punteggi. Le statistiche opzionali ti aiutano a capire il tuo gioco.",
  "startRound": "Iniziare un giro",
  "puttingHelp": "Conta i tuoi colpi sul verde.",
  "fairwayHelp": "Registra se il tuo tee shot trova la fairway su 4 e 5 buche.",
  "noMatch": "Nessun round corrisponde a questi filtri",
  "noMatchHelp": "Scegli un altro percorso, tee o conta buche per vedere i tuoi giri.",
  "resetFilters": "Rimuovere i filtri",
  "benchmark": "Il tuo primo benchmark",
  "benchmarkHelp": "Un altro giro comparabile inizierà una tendenza.",
  "whyOne": "Perche' un solo giro?",
  "excludedHelp": "{count} altri giri in questa finestra non hanno punteggi completi o affidabili storici par.",
  "historicalHelp": "I tuoi giri sono qui. I punteggi dei record e le statistiche opzionali nei round futuri per costruire i tuoi progressi.",
  "noScoring": "Nessun round di punteggio paragonabile ancora",
  "puttingTab": "Mettendo",
  "fairwaysTab": "Autostrade",
  "greensTab": "GIR",
  "perHole": "putt / buca registrato",
  "coverage": "Copertura registrata",
  "loggedCoverage": "{count} completati in questa finestra",
  "viewRounds": "Vedi i round",
  "roundUnavailable": "Questo giro non è disponibile.",
  "returnGolf": "Ritorno a Golf",
  "loadingCard": "Carica la tua scheda di punteggio",
  "restoringCard": "Ripristinare il buca attuale e i punteggi",
  "completeError": "Ogni giocatore ha bisogno di un punteggio su ogni buca prima che il round possa finire.",
  "stablefordNote": "Scoring lordo · Punti di Stableford in attesa di autorevoli handicap di gioco",
  "missingImage": "Anteprima del buca non disponibile",
  "roundComplete": "Tondo completo",

  "checkingLatest": "Controllare gli ultimi valori salvati...",
  "conflictTitle": "Revisione delle statistiche cambiate",
  "conflictHelp": "Le statistiche sono cambiate altrove, valutate i valori più recenti e la vostra bozza.",
  "latestSaved": "Ultimi salvati",
  "yourDraft": "Il tuo progetto non vistoso",
  "editedFieldsOnly": "Verranno salvati solo i campi modificati.",
  "useLatest": "Utilizzare i valori più recenti",
  "confirmReviewed": "Risparmiare modifiche",
  "holeCount": "{count} buchi",
  "evenPar": "Anche per me",

  "score_changed_reload": "Questo punteggio è cambiato altrove. L'ultimo punteggio salvato è mostrato; il valore è mantenuto come un progetto. Rivedere e confermarlo di nuovo.",
  "putts_exceed_score": "Il punteggio è inferiore a quello registrato putts. Regolare il punteggio o chiedere al golfer di rivedere i loro putt.",
  "answersRecorded": "{hits} di {count} registrati",
  "partialPutts": "{total} putts attraverso {count} di {holes} buche registrati",
  "scoreSaveError": "Questo punteggio non potrebbe essere salvato. Il tuo punteggio viene mantenuto. Controllare la connessione e riprovare.",
  "title": "Le mie macchie di buco",
  "optional": "Facoltativo",
  "support": "Aggiungi quanto vuoi o meno",
  "putts": "Putts",
  "fairway": "Strada giusta",
  "gir": "Verde nella regolamentazione",
  "girHelp": "Raggiungere il mettere verde in non più di par meno due colpi.",
  "yes": "Sì",
  "no": "No",
  "hit": "Hits",
  "missed": "Mancato",
  "clear": "Cancella",
  "clearAll": "Punteggi trasparenti",
  "unknownPar": "Storico par non disponibile; questa risposta non può essere registrata.",
  "na": "N/A",
  "increase": "Aumentare i putt",
  "decrease": "Diminuzione di putti",
  "retry": "Riprova",
  "saved": "Salvataggio",
  "saving": "Salvataggio…",
  "unsaved": "Non risparmiato",
  "saveError": "Non è stato possibile salvare le statistiche. Le modifiche sono conservate.",
  "progress": "Il mio campo da golf",
  "entrySubtitle": "Tondi, statistiche e miglioramento",
  "subtitle": "Il tuo gioco, nel tempo",
  "back": "Indietro",
  "courseTee": "percorso / percorsi",
  "holes": "Buche",
  "period": "Periodo",
  "lastRounds": "Ultimi {count} round",
  "allTime": "Tutto il tempo",
  "overview": "Panoramica",
  "trends": "Tendenze",
  "rounds": "Tondi",
  "scoreToPar": "Punteggio a par",
  "average": "Media a par",
  "best": "Miglior round",
  "roundStats": "Le tue statistiche tonde",
  "viewTrends": "Visualizza le tendenze",
  "putting": "Putts per buca",
  "fairways": "Fairway colpiti",
  "greens": "Verdi nella regolamentazione",
  "lower": "Più in basso è meglio",
  "higher": "Più alto è meglio",
  "par45": "Pari 4 e 5",
  "recordedOnly": "Sono incluse solo le statistiche registrate.",
  "holesRecorded": "{count} buchi registrati",
  "roundCoverage": "{count} giri completati · {holes} buche considerate",
  "scoreCoverage": "{count} di {total} round con totali punteggi lordi e affidabile storico par.",
  "noMetric": "Nessuna misura registrata in questo campo.",
  "oneRound": "Un round registrato. Più round mostrerà una tendenza.",
  "noHistory": "Nessun round completato disponibile",
  "emptyHelp": "Completa un round o scegli un altro filtro per vedere i tuoi progressi.",
  "window": "Storia di tutto il tempo, analizzata in pagine fino a 200 giri. Valori e grafici descrivono la pagina corrente.",
  "loading": "Caricamento dei tuoi progressi...",
  "loadError": "Non siamo riusciti a caricare i tuoi progressi.",
  "chartDescription": "Rotonde cronologiche. Le voci mancanti sono escluse. Aprire i dati del grafico per date, valori e copertura registrata.",
  "chartData": "Dati grafici: date, valori e copertura",
  "date": "Data",
  "value": "Valore",
  "recorded": "buche registrati",
  "pagination": "Pagine di storia rotonda",
  "previous": "Precedente",
  "next": "Avanti",
  "errors": {
    "invalid_putts": "Inserire un intero numero di putt da 0 a 30.",
    "putts_exceed_score": "I putt non possono superare il punteggio lordo salvato. Regolare i putt o il punteggio e riprovare.",
    "fairway_not_applicable": "Le fairway possono essere registrate solo su par 4 e par 5 buche.",
    "par_unavailable": "Il par storico non è disponibile per questo buco.",
    "stats_changed_reload": "Queste statistiche sono cambiate in un'altra richiesta. Rivedere le vostre voci prima di riprovare.",
    "round_not_editable": "Questo round non è più modificabile. Le modifiche non sono state salvate."
  }
}
